


































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    getPrograms,
    getOptions,
    patchBooking,
    deleteBooking,
    getBookings,
    patchBookingPrescriber,
    deleteBookingPrescriber,
    getBookingsPrescriber,
    postBookingDocumentAdmin,
    getBookingDocumentAdmin,
} from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import User from '../models/User';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { roles, formatRoles } from '@/data/roles';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import Program from '../models/Program';
import Booking from '../models/Booking';
import { Role } from '../models/Role';
import AuthModule from '../store/AuthModule';
import { fetchPrescriberBooking, fetchProgramsBooking, fetchPromotorsBooking, fetchProspectsAdminBooking , fetchOperatorsBooking } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import Datatable from '@/components/Datatable.vue';
import {
  formatBookingProgression,
  bookingProgressionColors, bookingProgression,
} from '@/data/bookingProgression';
import { formatBookingStatus, bookingStatusColors, bookingStatus } from '@/data/bookingStatus';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { denouceStatus } from '@/data/denouceStatus';

@Component({
    components: {
        Datatable,
        FilterComponent,
    },
    filters: {
        formatBookingProgression,
        formatBookingStatus,
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatDateHour: (value: string) => {
            return value ? moment(value).format('LT') : null;
        },
        formatPlus15: (value: string) => {
            if(value) {
                let date = moment(value).add(15, 'days');
                return date.format('L');
            }
            return null;
        },
    },
})


export default class Bookings extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 100,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            prescriber: undefined,
            program: undefined,
            customer: undefined,
            ProgressionResaModel: undefined,
            promotor: undefined,
            StatutResa: undefined,
            operator: undefined,
            year: null
        },
    };
    yearModel: string = 'all';
    operatorModel: string | undefined | null = null;
    deletePopUp: Boolean = false;
    type: string = '';
    bookingToDelete: Booking|null = null; 
    meta: MetaDatatable = cloneDeep(this.defaultMeta);

    get columns(): HeaderDatatable[] {
        if (this.roles.includes('ROLE_ADMIN')) {
            return [
                {
                    title: 'Code',
                    dataIndex: 'code',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'code',
                    },
                },
                {
                    title: 'Honoraires',
                    dataIndex: 'program',
                    scopedSlots: {
                        customRender: 'hono',
                    },
                },
                {
                  title: 'Date Réservation',
                  dataIndex: 'created_at',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'date',
                  },
                },
                {
                  title: 'Client',
                  dataIndex: 'customer',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'customer',
                  },
                },
                {
                    title: 'Prescripteur',
                    dataIndex: 'customer.prescriber',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'prescriber',
                    },
                },

                {
                    title: 'Opérateur',
                    dataIndex: 'operator',
                    sorter: true,
                    scopedSlots: { customRender: 'operator' },
                    },



                {
                    title: 'Statut prescripteur',
                    dataIndex: 'customer.prescriber.family',
                    sorter: true,
                },
                {
                  title: 'Avancement Résa.',
                  dataIndex: 'progression',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'progression',
                  },
                },
                {
                  title: 'Statut Résa.',
                  dataIndex: 'status',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'status',
                  },
                },
                {
                  title: 'Date paiement hono.',
                  dataIndex: 'date_payment_hono',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'date',
                  },
                },
                {
                  title: 'Date signature d\'acte',
                  dataIndex: 'loan_reception_deadline',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'date_acte',
                  },
                },
                {
                  title: 'Dernière Modif.',
                  dataIndex: 'updated_at',
                  sorter: true,
                  scopedSlots: {
                    customRender: 'updated_at',
                  },
                },
                {
                    title: 'Programme',
                    dataIndex: 'lot.program',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'program',
                    },
                },
                {
                    title: 'Lot',
                    dataIndex: 'lot',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'lot',
                    },
                },
                {
                    title: 'Ville du bien',
                    dataIndex: 'lot.program.address.city',
                    sorter: true,
                },
                {
                    title: 'Nom du vendeur/Promoteur',
                    dataIndex: 'lot.program.promoter',
                    sorter: true,
                    scopedSlots: {
                        customRender: 'promoter',
                    },
                },
                {
                    title: 'Actions',
                    dataIndex: 'action',
                    scopedSlots: {
                        customRender: 'actions',
                    },
                    fixed: 'right',
                },
            ];
        }

        return [
            {
                title: 'Code',
                dataIndex: 'code',
                sorter: true,
                scopedSlots: {
                    customRender: 'code',
                },
            },
            {
                title: 'Programme',
                dataIndex: 'lot.program',
                sorter: true,
                scopedSlots: {
                    customRender: 'program',
                },
            },
            {
                title: 'Lot',
                dataIndex: 'lot',
                sorter: true,
                scopedSlots: {
                    customRender: 'lot',
                },
            },
            {
                title: 'Ville du bien',
                dataIndex: 'lot.program.address.city',
                sorter: true,
            },
            {
                title: 'Nom du vendeur/Promoteur',
                dataIndex: 'lot.program.promoter',
                sorter: true,
                scopedSlots: {
                    customRender: 'promoter',
                },
            },
            {
                title: 'Client',
                dataIndex: 'customer',
                sorter: true,
                scopedSlots: {
                    customRender: 'customer',
                },
            },
            {
                title: 'Avanacement Résa.',
                dataIndex: 'progression',
                scopedSlots: {
                    customRender: 'progression',
                },
            },
            {
                title: 'Statut Résa.',
                dataIndex: 'status',
                scopedSlots: {
                    customRender: 'status',
                },
            },

            {
                title: 'Date Réservation',
                dataIndex: 'created_at',
                sorter: true,
                scopedSlots: {
                    customRender: 'date',
                },
            },
            {
                title: 'Statut prescripteur',
                dataIndex: 'user.family',
                scopedSlots: {
                    customRender: 'user.family',
                },
            },
        ];
    }

    async fetch(meta: MetaDatatable) {
        if (this.roles.includes('ROLE_ADMIN')) {
            const { data } = await getBookings({
                ...meta,
                page: meta.page - 1,
            });
            console.log('data', data);
            return data;
        } else {
            const { data } = await getBookingsPrescriber({
                ...meta,
                page: meta.page - 1,
            });
            return data;
        }
    }
    deleteText = {
        confirm: {
            title: `Suppression de la réservation`,
            content: `Voulez-vous vraiment supprimer la réservation ?`,
        },
        notify: {
            title: 'Reservation supprimée',
            content: `La reservation a bien été supprimée`,
        },
    };
    editText = {
        notify: {
            title: 'Réservation modifiée',
            content: `La réservation a bien été modifiée`,
        },
    };
    searchProgram = debounce(this.fetchPrograms, 300);
    searchPrescriber = debounce(this.fetchPrescriber, 300);
    prescriberItems: any[] = [];
    programsItems: any[] = [];

    get roles(): Role[] {
        return AuthModule.roles;
    }

        get fetchOperator() {
        return fetchOperatorsBooking;
    }

    // Prescibers
    get fetchPrescriber() {
        return fetchPrescriberBooking;
    }

    // Programs
    get fetchPrograms() {
        return fetchProgramsBooking;
    }

    get fetchCustomer() {
        return fetchProspectsAdminBooking;
    }

    get fetchPromotor(){
        return fetchPromotorsBooking;
    }

    get bookingProgressionArr(){
        return Object.keys(bookingProgression).map(key => ({
            text: (bookingProgression as any)[key],
            value: key,
        }));
    }

  get bookingStatusArr(){
    return Object.keys(bookingStatus).map(key => ({
      text: (bookingStatus as any)[key],
      value: key,
    }));
  }

    get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years: { text: string; value: string }[] = [
            { text: 'Tous', value: 'all' }
        ];
        for (let year = currentYear; year >= 2021; year--) {
            years.push({ text: year.toString(), value: year.toString() });
        }
        return years;
    }

    @Watch('yearModel', { immediate: true })
    onYearModel() {
        this.meta.filters = {
            ...this.meta.filters,
            year: this.yearModel === 'all' ? null : this.yearModel
        };
    }


    @Watch('operatorModel', { immediate: true })
    onOperatorModel() {
        if (this.operatorModel) {
            this.meta.filters = {
                ...this.meta.filters,
                operator: this.operatorModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                ...this.meta.filters,
                operator: null
            };
        }
    }



    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Booking | null;
    }) {
        const action = ev.action;
        const option: Booking | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (option && option.id) {
                    let editStatus: Booking = {
                        status: option.status,
                    };
                    if (this.roles.includes('ROLE_ADMIN')) {
                        await patchBooking(option.id, editStatus);
                    } else if (this.roles.includes('ROLE_PRESCRIBER')) {
                        await patchBookingPrescriber(option.id, editStatus);
                    }
                }
                break;
            case 'delete':
                if (option && option.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    if (this.roles.includes('ROLE_ADMIN')) {
                        await deleteBooking(option.id, this.type);
                    } else if (this.roles.includes('ROLE_PRESCRIBER')) {
                        await deleteBookingPrescriber(option.id);
                    }
                }
                break;
        }
    }

    deleteDialog(booking: Booking) {
        this.bookingToDelete = booking;
        this.deletePopUp = true;
    }

    deleteBookingAction(type: string) {
        this.type = type
        if(this.bookingToDelete) 
            this.acceptDeleteAlert(this.bookingToDelete);
            this.deletePopUp = false;
            this.bookingToDelete = null;
    }

    async editStatus(booking: Booking) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'edit', item: booking });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.editText.notify.title,
                text: this.editText.notify.content,
            });
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la modification de la réservation`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    async acceptDeleteAlert(booking: Booking) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: booking });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de l'option`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    get bookingProgressionColors() {
        return bookingProgressionColors;
    }

    get bookingStatusColors() {
        return bookingStatusColors;
    }

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    prescriberModel: string | undefined | null = null;
    programModel: string | undefined | null = null;
    clientModel: string | undefined | null = null;
    ProgressionResaModel: string | undefined | null = null;
    promotorModel: string | undefined | null = null;
    StatutResaModel: string | undefined | null = null;

    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.prescriber) {
            this.prescriberModel = this.meta.filters.prescriber;
        } else {
            this.prescriberModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.program) {
            this.programModel = this.meta.filters.program;
        } else {
            this.programModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.customer) {
            this.clientModel = this.meta.filters.customer;
        } else {
            this.clientModel = undefined;
        }
        if (this.meta.filters && this.meta.filters.progressionResa) {
            this.ProgressionResaModel = this.meta.filters.progressionResa;
        } else {
            this.ProgressionResaModel = undefined;
        }
        if (this.meta.filters && this.meta.filters.StatutResa) {
          this.StatutResaModel = this.meta.filters.StatutResa;
        } else {
          this.StatutResaModel = undefined;
        }
        if (this.meta.filters && this.meta.filters.promotor) {
            this.promotorModel = this.meta.filters.promotor;
        } else {
            this.promotorModel = undefined;
        }
        if (this.meta.filters && this.meta.filters.year) {
            this.yearModel = this.meta.filters.year;
        } else {
            this.yearModel = 'all';
        }


        if (this.meta.filters && this.meta.filters.operator) {
                this.operatorModel = this.meta.filters.operator;
            } else {
                this.operatorModel = undefined;
            }


    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters = {
                prescriber: this.prescriberModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                prescriber: null
            };
        }
    }

    @Watch('programModel', { immediate: true })
    onProgramModel() {
        if (this.programModel) {
            this.meta.filters = {
                program: this.programModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                program: null
            };
        }
    }

    @Watch('clientModel', { immediate: true })
    onClientModel() {
        if (this.clientModel) {
            this.meta.filters = {
                customer: this.clientModel
            };

        } else if (this.meta.filters) {
            this.meta.filters = {
                customer: null
            };
        }
    }

    @Watch('ProgressionResaModel', { immediate: true })
    onProgressionResaModel() {

        if (this.ProgressionResaModel) {
            this.meta.filters = {
                progressionResa: this.ProgressionResaModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                progressionResa: null
            };
        }
    }

    @Watch('StatutResaModel', { immediate: true })
    onStatutResaModel() {

        if (this.StatutResaModel) {
            this.meta.filters = {
              StatutResa: this.StatutResaModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
              StatutResa: null
            };
        }
    }

    @Watch('promotorModel', { immediate: true })
    onPromotorModel() {

        if (this.promotorModel) {
            this.meta.filters= {
                promotor: this.promotorModel
            };
        } else if (this.meta.filters) {
            this.meta.filters= {
                promotor: null
            };
        }
    }

    async setDefaultOperatorFilter() {
    try {
        // Get the current user ID from AuthModule
        const currentUserId = AuthModule.userID;
        
        if (!currentUserId || currentUserId === -1) {
            this.operatorModel = undefined;
            console.log('No current user logged in');
            return;
        }

        // Check if current user is in the list of operators for denounces
        const operators = await fetchOperatorsBooking(''); // Get all operators
        
        // Look for current user in the operators list - FIX: Add type annotation
        const isCurrentUserAnOperator = operators.some((operator: any) => 
            operator.value === currentUserId
        );

        if (isCurrentUserAnOperator) {
            // Set the operator filter to current user
            this.operatorModel = currentUserId.toString();
            
            // Also update the meta filters immediately
            this.meta.filters = {
                ...this.meta.filters,
                operator: currentUserId
            };
            
            console.log('Auto-filtered to current user operator:', AuthModule.firstname, AuthModule.lastname);
        } else {
            this.operatorModel = undefined;
            console.log('Current user is not an operator in denounces');
        }
        
    } catch (error) {
        console.log('Error setting default operator filter:', error);
        this.operatorModel = undefined;
    }
}




    async created(){
        this.prescriberModel = undefined;
        this.programModel = undefined;
        this.clientModel = undefined;
        this.ProgressionResaModel = undefined;
        this.promotorModel = undefined;
        this.StatutResaModel = undefined;
        this.operatorModel = undefined;
        this.yearModel = 'all';

        await this.setDefaultOperatorFilter();

    }
}
